import globals from '../../common/globals';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import vxStepperControl from '../../common/vx-stepper-control/vx-stepper-control.vue';
import vxNotifyMe from '../../search-browse/vx-notify-me/vx-notify-me.vue';
import flyoutBannerMixin from '../../common/vx-flyout-banner/vx-flyout-banner-mixin';
import vxModal from '../../common/vx-modal/vx-modal.vue';

export default {
  name: 'vx-product-tile',
  mixins: [flyoutBannerMixin],
  components: {
    vxSpinner,
    vxStepperControl,
    vxNotifyMe,
    vxModal,
  },
  props: {
    // To determine axis of the tile
    verticle: {
      type: Boolean,
      default: false,
    },
    // To determine layout of the tile
    layout: {
      type: String,
    },
  },
  data() {
    return {
      globals,
      savedAmount: 0,
      pdpContextPath: '',
    };
  },
  computed: {},
  mounted() { },
  methods: {
    /**
    * Set product Quantity
    */
    setQuantity(newQty) {
      this.product.quantity = newQty;
    },
    /**
    * Handle product Quantity
    */
    handleQuantity(quantity) {
      this.savedAmount = this.product.price.value * quantity;
      this.product.quantity = quantity;
      this.product.price.finalPrice = this.product.price.value * quantity;
      this.$emit('quantity-updated', this.product);
    },
    /**
    * Open Notify me modal
    */
    notifyMe() {
      this.$refs.notifyMeModal.open();
    },
    /**
    * Show flyout on error and close notify me modal
    */
    onNotifyMeError(error) {
      this.$refs.notifyMeModal.close();
      this.showFlyout('error', error, true);
    },
    /**
    * Open Notify me modal
    */
    onNotifyMeSuccess(success) {
      this.$refs.notifyMeModal.close();
      this.showFlyout('success', success, true);
    },
    /**
    * Delete Cart Product
    */
    deleteCartItem() {
      this.$emit('item-deleted', this.product);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-product-tile/vx-product-tile.js